/** @param {string} optionId @param {{ kind?: string } | undefined} [question] */
export function resolveAgentQuestionOptionSendText(optionId, question) {
  if (question?.kind === 'designDnaFigmaPublish') {
    return null
  }
  const id = optionId.toLowerCase()
  if (id === 'a') return 'create xl sheet'
  if (id === 'b') return 'create doc'
  if (id === 'c') return 'create app'
  return null
}

/** @param {string} optionId @param {{ freeTextOptionId?: string | null }} [question] */
export function isAgentQuestionFreeTextOption(optionId, question) {
  if (question && Object.prototype.hasOwnProperty.call(question, 'freeTextOptionId')) {
    if (question.freeTextOptionId == null) return false
    return optionId.toLowerCase() === question.freeTextOptionId.toLowerCase()
  }
  return optionId.toLowerCase() === 'd'
}
